import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import heroImg from "@/assets/pulso33-hero.jpg";
import { useT, useMedia } from "@/lib/i18n";

export const Route = createFileRoute("/about/mision")({
  component: MissionPage,
  head: () => ({
    meta: [
      { title: "Mission & Values — PULSO33" },
      { name: "description", content: "How PULSO33 works: pragmatic engineering, transparent collaboration and long-term partnership." },
      { property: "og:title", content: "Mission & Values — PULSO33" },
      { property: "og:description", content: "Pragmatic engineering, transparent collaboration, long-term partnership." },
      { property: "og:url", content: "https://pulso33.com/about/mision" },
      { property: "og:image", content: heroImg },
    ],
    links: [{ rel: "canonical", href: "https://pulso33.com/about/mision" }],
  }),
});

function MissionPage() {
  const { tk } = useT();
  const hero = useMedia("about.hero", heroImg, "PULSO33 team at work");

  return (
    <Layout>
      <section className="border-y border-gold/15 bg-card/40">
        <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-xs tracking-[0.4em] uppercase text-gold">{tk("mision.kicker", "Our Mission")}</span>
            <h1 className="font-serif text-4xl md:text-5xl mt-4">
              {tk("mision.title", "Transform the IT areas that matter most to your business.")}
            </h1>
            <div className="gold-divider my-6 max-w-[100px]" />
            <p className="text-muted-foreground leading-relaxed">
              {tk("mision.intro", "We build long-term relationships based on transparency, technical depth and outcomes you can measure. No buzzwords, no theatre — just systems that work.")}
            </p>
            <ul className="mt-8 space-y-4">
              {[
                tk("mision.v1", "Pragmatic engineering. We pick the right tool, not the trendy one."),
                tk("mision.v2", "Transparent pricing and timelines. No surprises."),
                tk("mision.v3", "Real ownership. We ship to production and stand behind it."),
                tk("mision.v4", "AI where it earns its keep — never as a sticker."),
              ].map((v) => (
                <li key={v} className="flex gap-4">
                  <span className="text-gold font-serif text-xl leading-none">✦</span>
                  <span className="text-foreground/80">{v}</span>
                </li>
              ))}
            </ul>
            <Link to="/contact" className="mt-10 inline-flex items-center gap-3 rounded-full bg-gold text-primary-foreground px-7 py-3.5 text-xs tracking-[0.3em] uppercase hover:bg-[oklch(0.88_0.08_85)] transition-colors">
              {tk("mision.cta", "Get in touch")}
            </Link>
          </div>
          <div className="relative">
            <img src={hero.url} alt={hero.alt} width={1200} height={1400} loading="lazy" className="w-full h-[560px] object-cover rounded-xl" />
          </div>
        </div>
      </section>
    </Layout>
  );
}
